import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  maritalStatus: 0,
  employmentStatus: {},
  taxpayerJobs: [],
  spouseJobs: [],
  employmentLoadingStatus: '',
  realEstate: [],
  realEstateLoadingStatus: '',
  vehicles: [],
  vehiclesLoadingStatus: '',
  otherAssets: [],
  otherAssetsLoadingStatus: '',
  household: {},
  householdLoadingStatus: '',
  itemDetails: null,
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
